import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _AddCrossReference, _ProductPhoto } from "../../../core/services/dataBean/EntityCatalogVdos";
import { FileService } from "../../../core/services/FileService";
import { FileInput } from "../../theme/Component/FileInput";


interface Props {
    idProduct: number;
}
export const ProductCrossReference = ({ idProduct }: Props) => {

    const proref = useDataBean(_AddCrossReference);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const fileService = new FileService();
    useEffect(() => {
        getLista();
    }, [idProduct])

    const getLista = () => {

        proref.instance.getProductCrossReferenceCatalog(idProduct).then(
            (resp: any) => {
                setLista(resp)

            }
        )

    }

    const create = () => {
        proref.setBean({
            IDProduct: idProduct
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        proref.instance.deleteProductCrossReference(proref.bean.IDProductCrossReference).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        proref.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID Producto', property: 'IDProductParent', visible: true },
        { title: 'Nombre Relación', property: 'Name', visible: true },
        { title: 'Descripción Relación', property: 'Description', visible: true },
        { title: 'Nombre de Producto', property: 'ParentDescription', visible: true },
        { title: 'Referencia Producto', property: 'ParentReference', visible: true },
        { title: 'Código Producto', property: 'ParentProductCode', visible: true },
        { title: 'SKU Producto', property: 'ParentStockKeepingUnit', visible: true },
        { title: 'Unidad Medida', property: 'MeasurementUnitCode', visible: true },
        { title: 'Unidad Medida UBL', property: 'UBLMeasurementUnitCode', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Referencias Relacionadas">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={proref.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={proref.bean.Name} onChange={proref.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={proref.bean.Description} onChange={proref.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {proref.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}